export enum TokenSortMethod {
  ASSET = 'Asset',
  AMOUNT = 'Amount',
  VALUE = 'Value',
}
